import { model } from "core/util";

export const Validity = model.createModelLegacy("Validity", (json) => ({
    technicalDateValidFrom: json.TechnicalDateValidFrom,
    technicalDateValidTo: json.TechnicalDateValidTo,
    dateValidFrom: json.DateValidFrom,
    dateValidTo: json.DateValidTo,
}));
